import { Box, ImageListItem, ImageListItemBar } from "@mui/material";
import React from "react";
import { ETextureOrigin, IAssetTexture } from "../../@types/ContextProviderRelated";
import { EInteractionMode } from "../../@types/Enums";
import { EAssetType, IFilesApiColor } from "../../@types/FilesAPIModels";
import { useBuilding } from "../../provider/BuildingProvider/BuildingProvider";
import { useToolbarContext } from "../../provider/ToolbarProvider";

interface ColorImageListItemProps {
  color: IFilesApiColor;
  index: number;
}

const ColorImageListItem: React.FC<ColorImageListItemProps> = ({ color }) => {
  const { setSelectedTexture, getSelectedModel: getSelectedObject, applyTextureToStoredObject } = useBuilding();
  const { setInteractionMode } = useToolbarContext();

  const applyColor = () => {
    const textureInfo: IAssetTexture = {
      textureOrigin: ETextureOrigin.ASSET,
      id: color.id,                  
      name: color.name,
      type: EAssetType.COLOR,
      material: null,
      color: color.hex,
      rotation: 0,
      offset: 0,
    };

    const immediate = Boolean(getSelectedObject());
    if (immediate) {
      // apply immediately
      setSelectedTexture(textureInfo, true);
      setTimeout(() => {
        applyTextureToStoredObject();
        setInteractionMode(EInteractionMode.NONE);
      }, 0);
    } else {
      // defer until user clicks on model
      setSelectedTexture(textureInfo);
      setInteractionMode(EInteractionMode.SET_TEXTURE);
    }
  };

  return (
    <ImageListItem
      key={`colorAsset-${color.id}`}
      sx={{
        width: "100px !important",
        height: "100px !important",
        cursor: "pointer",
      }}
      onClick={applyColor}
    >
      <Box
        sx={{
          backgroundColor: color.hex,
          width: "100%",
          height: "100%",
        }}
      />
      <ImageListItemBar
        title={color.name}
        sx={{
          "& .MuiImageListItemBar-title": {
            fontSize: "12px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }}
      />
    </ImageListItem>
  );
};

export default ColorImageListItem;
